<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="
          md-layout-item
          md-small-size-100
          md-medium-size-100
          md-xsmall-size-100
          md-size-100
        "
      >
        <div>
          <!-- Loading state handler -->
          <div v-if="isLoading"><LoadingData /></div>

          <!-- Data Handler -->
          <div v-else>
            <!-- Empty Data Handler -->
            <div v-if="isEmpty"><EmptyData /></div>

            <!-- Data Exist Handler -->
            <div v-else>
              <div class="text-right">
                <md-button
                  class="md-raised md-primary"
                  @click="openAddToBusinessModal()"
                  >Add Team Member</md-button
                >
                <!-- Manage Team Button -->
                <!-- <md-button
                class="md-raised"
                data-background-color="orange"
                @click="openCustomRoleModal()"
                >Manage Team</md-button
              > -->
              </div>
              <md-table table-header-color="green">
                <md-table-row>
                  <md-table-head>Name</md-table-head>
                  <md-table-head>Email Address</md-table-head>
                  <md-table-head>Phone Number</md-table-head>
                  <md-table-head>Role</md-table-head>
                  <md-table-head>Member Since</md-table-head>
                  <md-table-head>Action</md-table-head>
                </md-table-row>

                <md-table-row v-for="(t, index) in teamAccesses" :key="index">
                  <!-- Name -->
                  <md-table-cell md-label="Name">
                    <b v-if="isLoggedUser(t.user.id)">You</b>
                    <p v-else>{{ t.user.name }}</p>
                  </md-table-cell>
                  <!-- Email Address -->
                  <md-table-cell md-label="Name">{{
                    t.user.email
                  }}</md-table-cell>
                  <!-- Phone Number -->
                  <md-table-cell md-label="Name">{{
                    t.user.phone
                  }}</md-table-cell>
                  <!-- Role -->
                  <md-table-cell md-label="Role"> {{ t.roles }} </md-table-cell>
                  <!-- Member since -->
                  <md-table-cell md-label="Name">{{
                    format(t.created_at, 'DD/MM/YYYY hh:mm a')
                  }}</md-table-cell>
                  <!-- Action -->
                  <md-table-cell md-label="Action">
                    <span v-if="isLoggedUser(t.user.id) || t.roles === 'OWNER'"> {{ null }}</span>
                    <span v-else
                      ><md-button
                        class="md-primary"
                        @click="openChangeRoleModal(t)"
                        >Change
                      </md-button>
                      <md-button class="md-primary" @click="openConfirmModal(t)"
                        >Remove</md-button
                      ></span
                    >
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Delete Modal -->
    <ConfirmModal
      ref="confirmModal"
      :removeBusinessAccess="removeBusinessAccess"
    />

    <!-- Add To Business Modal -->
    <AddToBusinessModal
      ref="addToBusinessModal"
      :createBusinessAccess="createBusinessAccess"
    />

    <!-- Change Role Modal -->
    <ChangeRoleModal ref="changeRoleModal" :updateRole="updateRole" />

    <!-- Custom Role Modal -->
    <!-- <CustomRoleModal
      ref="customRoleModal"
      :openCustomRoleModal="openCustomRoleModal"
    /> -->

    <md-snackbar
      md-position="center"
      :md-duration="6000"
      :md-active.sync="snackBar.show"
      md-persistent
    >
      <span>{{ snackBar.message }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import format from 'date-fns/format';
import http from '../../../utils/Http.util';

// Modals
import ConfirmModal from './ConfirmModal.vue';
import ChangeRoleModal from './ChangeRoleModal.vue';
import AddToBusinessModal from './AddToBusinessModal.vue';

// Data
import EmptyData from '../../../components/EmptyData.vue';
import LoadingData from '../../../components/LoadingData.vue';

export default {
  components: {
    ConfirmModal,
    ChangeRoleModal,
    AddToBusinessModal,
    EmptyData,
    LoadingData,
  },
  created() {
    this.getUsers();
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
    isEmpty() {
      return !this.teamAccesses.length;
    },
  },
  data() {
    return {
      // validRoles,
      snackBar: {
        show: false,
        message: null,
      },
      teamAccesses: [],
      isLoading: false,
    };
  },
  methods: {
    format,
    async getUsers() {
      try {
        this.isLoading = true;
        const result = await http.authReq('/dashboard/business-accesses');
        this.isLoading = false;
        const { data } = result;

        this.pushUserToTop(data);
        this.teamAccesses = data;
      } catch (err) {
        this.isLoading = false;
        this.snackBar = {
          show: true,
          message: err.response ? err.response.data.message : err.message,
        };
      }
    },
    isLoggedUser(userId) {
      if (userId === this.teamAccesses[0].user_id) {
        return true;
      }
      return false;
    },
    async pushUserToTop(businessAccess) {
      // STEP 1: Get the user's index
      const index = await businessAccess
        .map((data) => data.user_id)
        .indexOf(this.userData.id);
      // STEP 2: Remove the user from the array at a particular index
      const removed = await businessAccess.splice(index, 1);
      // STEP 3: Add a user to the start of the array
      await businessAccess.unshift(removed[0]);
    },
    async updateRole(form) {
      const { id, roles } = form;
      this.$store.commit('busyStatus', true);
      try {
        const result = await http.authReq(
          `/dashboard/business-accesses/${id}`,
          { roles },
          'patch',
        );

        this.getUsers();
        this.$refs.changeRoleModal.close();
        this.$store.commit('busyStatus', false);
        this.snackBar = {
          show: true,
          message: result.message,
        };
      } catch (err) {
        this.$store.commit('busyStatus', false);
        this.snackBar = {
          show: true,
          message: err.response ? err.response.data.message : err.message,
        };
      }
    },
    async removeBusinessAccess(item) {
      this.$store.commit('busyStatus', true);
      try {
        const result = await http.authReq(
          `/dashboard/business-accesses/${item.id}`,
          null,
          'delete',
        );
        this.$refs.confirmModal.close();
        this.$store.commit('busyStatus', false);
        this.getUsers();
        this.snackBar = {
          show: true,
          message: result.message,
        };
      } catch (err) {
        this.$store.commit('busyStatus', false);
        this.snackBar = {
          show: true,
          message: err.response ? err.response.data.message : err.message,
        };
      }
    },
    async createBusinessAccess(form) {
      const { phone, email, roles } = form;

      if (!email || !phone || !roles) {
        this.snackBar = {
          show: true,
          message: 'Please enter all fields',
        };
        return;
      }

      try {
        this.$store.commit('busyStatus', true);

        const { message } = await http.authReq(
          '/dashboard/business-accesses',
          {
            ...form,
          },
          'post',
        );

        this.$refs.addToBusinessModal.close();
        this.getUsers();
        this.$store.commit('busyStatus', false);

        this.snackBar = {
          show: true,
          message,
        };
      } catch (error) {
        this.$store.commit('busyStatus', false);
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
      }
    },
    openAddToBusinessModal() {
      this.$refs.addToBusinessModal.open();
    },
    openChangeRoleModal(t) {
      this.$refs.changeRoleModal.open(t);
    },
    openConfirmModal(t) {
      this.$refs.confirmModal.open(t);
    },
  },
};
</script>

<style>
.page-btn {
  margin-right: 20px;
  font-size: 20px !important;
}
.md-menu-content {
  z-index: 11 !important;
}
</style>
